import { useEffect, useRef, useState } from 'react';
import './searchInput.css';

const AnimatedSearchInput = ({
    name,
    id = name,
    value,
    onChange,
    type,
    onSubmit,
    placeholderTexts,
    animatePlaceholder = true,
    disabled = false,
    fullWidth = false,
    ...props
}) => {
    const [currentText, setCurrentText] = useState('');
    const [textIndex, setTextIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef();

    useEffect(() => {
        if (!animatePlaceholder || isFocused) return;
        const currentMessage = placeholderTexts[textIndex];

        const timeout = setTimeout(
            () => {
                if (!isDeleting && charIndex < currentMessage.length) {
                    setCurrentText(currentMessage.slice(0, charIndex + 1));
                    setCharIndex(charIndex + 1);
                } else if (!isDeleting && charIndex === currentMessage.length) {
                    setTimeout(() => setIsDeleting(true), 1000);
                } else if (isDeleting && charIndex > 0) {
                    setCurrentText(currentMessage.slice(0, charIndex - 1));
                    setCharIndex(charIndex - 1);
                } else if (isDeleting && charIndex === 0) {
                    setIsDeleting(false);
                    setTextIndex((textIndex + 1) % placeholderTexts.length);
                }
            },
            isDeleting ? 50 : 50
        );
        return () => clearTimeout(timeout);
    }, [charIndex, isDeleting, textIndex, isFocused, placeholderTexts, animatePlaceholder]);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && onSubmit) {
            onSubmit(value);
        }
    };

    return (
        <div className='search-container full-width'>
            {animatePlaceholder && !isFocused && !value && (
                <span className='animated-placeholder' onClick={() => inputRef.current.focus()}>
                    {currentText}
                    <span className='cursor'>|</span>
                </span>
            )}
            <input
                ref={inputRef}
                type={type}
                name={name}
                id={id}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKeyDown}
                onFocus={handleFocus}
                onBlur={handleBlur}
                placeholder={''}
                disabled={disabled}
                {...props}
            />
        </div>
    );
};

export default AnimatedSearchInput;
